import { inject, Injectable, Injector } from '@angular/core';
import { ConnectorBaseService } from '@libs/shared/common';
import { ConnectionAuthModel, ConnectionAuthProvider, ConnectionParams, EndpointType } from '@libs/shared/models';
import { Observable, of, take } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CustomerConnectorService {
  private readonly tokenBasedAuthEndpoints: EndpointType<'customer'>[] = ['customers', 'customerByNumber'];

  private readonly connectorBase: ConnectorBaseService = inject(ConnectorBaseService);
  private readonly injector: Injector = inject(Injector);

  public connect<T>(endpoint: EndpointType<'customer'>, params?: ConnectionParams): Observable<T> {
    return this.getAuth(endpoint).pipe(
      take(1),
      switchMap(auth => this.connectorBase.connect<T>('customer', endpoint, auth, params)),
    );
  }

  private getAuth(endpoint: EndpointType<'customer'>): Observable<ConnectionAuthModel | undefined> {
    const authProvider: ConnectionAuthProvider | null = this.injector.get(ConnectionAuthProvider, null);

    if (!authProvider) {
      return of(undefined);
    }

    return this.tokenBasedAuthEndpoints.includes(endpoint)
      ? authProvider.getTokenBasedAuth()
      : authProvider.getAuth();
  }
}
